import { Injectable } from '@angular/core';

@Injectable()
export class UtilityService{

    TestingFunction(): boolean {
        return true;
    }
}